<template>
  <div class="home-container">
    <div class="container banner-container">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img :src="item.adverImage" style="width:1200px;height: 430px"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--<div class="container">-->
      <!--<div class="title-container">-->
        <!--<div class="title">-->
          <!--<p>拼团</p>-->
        <!--</div>-->
        <!--<div class="switch-button-wrapper">-->
          <!--<router-link to="/assembles" class="check-more">查看更多<i class="fa fa-chevron-right"></i></router-link>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="container special-offer recommend-container">-->
      <!--<div class="recommend-wrapper">-->
        <!--<el-card class="sku-item-card" v-if="assembleList.length" shadow="hover" style="height:303px" v-for="sku in assembleList" :key="sku.id" >-->
          <!--<div  @click="toAssemble(sku.id,sku.skuId,sku.proportion)">-->
            <!--<div class="sku-cover-wrapper" >-->
              <!--<el-image-->
                  <!--class="sku-cover"-->
                  <!--:src="sku.imgUrl"-->
                  <!--fit="contain"-->
              <!--&gt;-->
              <!--</el-image>-->
            <!--</div>-->
            <!--<div class="sku-description">-->
              <!--<p class="name">{{sku.skuName}}</p>-->
              <!--<p class="purpose">{{sku.skuSharerDescribe}}</p>-->
            <!--</div>-->
            <!--<div style="padding: 6px 5px;">-->
              <!--<div class="v-progress-component">-->
                <!--<span class="v-proportion">{{sku.proportion}}</span>-->
                <!--<div class="v-progress-wrapper" :style="{width:sku.proportion}"></div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="sku-footer">-->
              <!--<div class="l">-->

                <!--<p class="price"><span>¥</span>{{sku.skuPrice}}</p>-->
                <!--&lt;!&ndash;<span>{{sku.buyNum}}/{{sku.stock}}</span>&ndash;&gt;-->
                <!--<v-count-down :prefix="'剩余时间'" style="font-size: 12px;" :time="sku.closingDate"/>-->
              <!--</div>-->
              <!--<div class="r">-->
                <!--<p class="btn" :class="{'is-disabled':sku.proportion=='100.00%'}">立即抢购</p>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</el-card>-->
        <!--<div class="type-no-sku" v-if="!assembleList.length">-->
          <!--暂无拼团商品-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->

    <div class="container" v-if="shpSkuRecommendList.length">
      <div class="title-container">
        <div class="title">
          <p>热销商品</p>
        </div>
      </div>
    </div>
    <div class="container special-offer recommend-container">
      <div class="recommend-wrapper">
        <el-card class="sku-item-card" shadow="hover" v-for="sku in shpSkuRecommendList" :key="sku.id">
          <div class="sku-cover-wrapper" @click="toDetail(sku.skuId)">
            <el-image
                class="sku-cover"
                :src="sku.skuImg"
                fit="contain"
            >
            </el-image>
          </div>
          <div class="sku-description" @click="toDetail(sku.skuId)">
            <p class="name">{{sku.skuName}}</p>
            <p class="purpose">{{sku.skuSharerDescribe}}</p>
            <span class="sprice" v-if="sku.storePrice">门店价: <span>¥{{sku.storePrice}}</span></span>
            <span class="price">¥{{sku.skuPrice}}</span>
          </div>
        </el-card>
        <div class="type-no-sku" v-if="!shpSkuRecommendList.length">
          暂无热销商品
        </div>
      </div>
    </div>
    <div v-for='first in goodsList' :key="first.id">
      <div class="container">
        <div class="title-container" v-if="first.shopList.length>0">
          <div class="title">
            <p>{{first.categoryName}}</p>
          </div>
          <div class="switch-button-wrapper">
            <router-link :to="'/classify/'+first.id" class="check-more">查看更多<i class="fa fa-chevron-right"></i>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container recommend-container">
        <div class="recommend-wrapper">
          <el-card class="sku-item-card" shadow="hover" v-for='(sku,index) in first.shopList' :key="sku.id"
                   v-if="index<8">
            <router-link :to="'/detail/'+sku.id">
              <div class="sku-cover-wrapper">
                <el-image
                    class="sku-cover"
                    :src="sku.imgUrl"
                    fit="contain"
                >
                </el-image>
              </div>
              <div class="sku-description">
                <p class="name">{{sku.skuName}}</p>
                <p class="purpose">{{sku.skuSharerDescribe}}</p>
                <span class="sprice" v-if="sku.storePrice">门店价: <span>¥{{sku.storePrice}}</span></span>
                <span class="price">¥{{sku.skuPrice}}</span>
              </div>
            </router-link>
          </el-card>
<!--          <div class="type-no-sku" v-if="!first.shopList.length">-->
<!--            暂无商品-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import skuImg from './images/sku.png';
  import {mapGetters} from 'vuex';
  import Cookies from 'js-cookie';

  export default {
    data() {
      return {
        bannerList: [],
        skuImg,
        goodsList: [],
        shpSkuRecommendList: [],
        assembleList: []
      }
    },
    created() {
      this.getAdResources();
      this.getSkuRecommendList();
      const code =Cookies.get('code');
      this.getDetailedList(code);
      let defaultCity = Cookies.get('defaultCity');
      if (defaultCity) defaultCity = JSON.parse(defaultCity);
      this.getRegionCategorySku(defaultCity);
    },
    watch: {
      location(val) {
        this.getRegionCategorySku(val);
      },
      code(code) {
        this.getRegionCategorySku();
        this.getSkuRecommendList(code);
        this.getDetailedList(code);
      }
    },
    computed: {
      ...mapGetters(['firstMenu', 'twoMenu', 'location', 'code'])
    },
    methods: {
      // 拼团
      async getDetailedList(regionCode){
        let res = await this.$get('/api/getAssembleList',{
          regionCode,
          type: '1'
        });
        if(res.code==='200'){
          res.assembleList.forEach(sku=>{
            const stock = Number(sku.buyNum)+Number(sku.skuNum);
            sku['stock']= stock;
            const proportion = (Number(sku.buyNum)/stock *100).toFixed(2);
            sku['proportion'] =proportion+'%';
          });
          this.assembleList = res.assembleList;
        }else{
          this.assembleList = []
        }
      },
      // 推荐商品
      async getSkuRecommendList(code) {
        let res = await this.$get('/api/getSkuRecommendList', {
          regionCode: code == '' || code == undefined? '410700':code
        });
        this.shpSkuRecommendList = res.code === '200' ? res.shpSkuRecommendList : []
      },
      // 获取一级分类
      async getCategoryList() {
        let res = await this.$get('/api/getCategoryList');
        return res.code === '200' ? res.categoryList : []
      },
      // 根据一级分类ID和省市区ID获取所有商品
      async getRegionCategorySku() {
        let categoryList = await this.getCategoryList();
        let goodsList = [];
        let code = Cookies.get('code');
        for (let i = 0; i < categoryList.length; i++) {
          let item = categoryList[i];
          let params = {
            categoryId: item.id
          };
          if (code) {
            params.bbiChinaId = code;
          }
          let res = await this.$get('/api/getRegionCategorySku', params);
          if (res.code === '200') {
            goodsList.push({
              id: item.id,
              categoryName: item.categoryName,
              shopList: res.shopList
            })
          } else {
            goodsList.push({
              id: item.id,
              categoryName: item.categoryName,
              shopList: []
            })
          }
        }
        this.goodsList = goodsList;
      },
      // 获取轮播图
      async getAdResources() {
        let code = Cookies.get('code');
        let res = await this.$get('/api/getAdResources', {
          origin: '2',
          regionCode:code
        });
        if (res.code === '200') {
          this.bannerList = res.resources;
        }
      },
      // 跳转拼团商品详情页
      toAssemble(id,skuId,proportion){
        if(proportion==='100.00%'){
          return;
        }
        this.$router.push(`/assemble/${id}/${skuId}`)
      },
      // 跳转商品详情页
      toDetail(id) {
        this.$router.push('/detail/' + id)
      }
    }
  }
</script>

<style lang="scss">
  .banner-container {
    height: 430px;

    .el-carousel__container {
      height: 430px;
    }

    img {
      height: 430px;
    }
  }

  .special-offer {
    overflow: hidden;
  }

  .recommend-container {
    overflow: hidden;

    .recommend-wrapper {
      width: 1204px;
      overflow: hidden;

      .sku-item-card {
        margin-right: 12px;
        margin-bottom: 20px;
        width: 287px;
      }
    }
  }

  .empty-wrapper {
    margin-top: -20px;
    height: 12px;
    background: #f5f5f5;
  }

  .type-no-sku {
    height: 150px;
    text-align: center;
    line-height: 150px;
    font-size: 16px;
  }
  .v-progress-component{
    position: relative;
    width: 100%;
    height: 14px;
    border-radius: 8px;
    background: #e6e6e6;
    overflow: hidden;
    .v-proportion{
      position: absolute;
      left: 50%;
      top: 1px;
      font-size: 12px;
      transform: scale(0.8) translateX(-50%);
      color:#fff;
    }
    .v-progress-wrapper{
      width: 50%;
      height: 100%;
      border-radius: 8px;
      background: #f35b6f;
    }
  }
  .sku-footer{
    padding: 2px 12px 0;
    display: flex;
    justify-content: space-between;
    .r{
      display: flex;
      align-items: center;
    }
    .btn{
      width: 70px;
      height: 36px;
      font-size: 13px;
      color:#fff;
      line-height: 36px;
      background: #df0021;
      text-align: center;
      border-radius: 3px;
      &.is-disabled{
        cursor: no-drop;
        background: #ccc;
      }
    }
    .price{
      font-size: 20px;
      color:#f00;
      font-weight: bold;
      font-family: Arial;
      margin-bottom: 5px;
      span{
        color:#f00;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
  .sprice{
    font-size: 16px;
    color: rgba(0, 0, 0, 0.64);
    font-family: Arial;
    margin-bottom: 5px;
    margin-right: 20px;
    span{
      text-decoration:line-through;
      color: rgba(0, 0, 0, 0.64);
      font-size: 14px;
      font-weight: normal;
    }
  }
</style>
